import { CountryIconProps } from './types';

const BQ1 = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3698)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M12 0.000981008C11.9888 -0.00745649 -0.00318686 11.9978 6.35322e-07 12.001C6.35322e-07 5.37361 5.37262 0.000981008 12 0.000981008Z"
        fill="#D80027"
      />
      <path
        d="M12 4.44543e-06C12.0112 -0.00843305 24.0032 11.9968 24 12C24 5.37263 18.6274 4.44543e-06 12 4.44543e-06Z"
        fill="#D80027"
      />
      <path
        d="M12 23.9994C11.9888 24.0078 -0.00318686 12.0026 6.35322e-07 11.9994C6.35322e-07 18.6268 5.37262 23.9994 12 23.9994Z"
        fill="#0052B4"
      />
      <path
        d="M12 23.9989C12.0112 24.0073 24.0032 12.0021 24 11.9989C24 18.6263 18.6274 23.9989 12 23.9989Z"
        fill="#0052B4"
      />
      <path
        d="M11.9995 6.26074L13.2946 10.2465H17.4855L14.0949 12.7098L15.39 16.6956L11.9995 14.2322L8.60908 16.6956L9.90414 12.7098L6.51367 10.2465H10.7045L11.9995 6.26074Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3698">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BQ1;
